import React from "react";

export const KeyIcon = ({
  height = "24",
  width = "24",
}: {
  height?: string;
  width?: string;
}) => (
  <svg
    width={width}
    height={height}
     viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.5803 6.87832C9.5803 7.62847 9.5803 8.35554 9.82069 9.03645C7.29369 11.9563 0 20.2599 0 20.2599L0.17003 22.3545C0.17003 22.3545 2.21039 24.2588 2.51527 23.9702C3.41819 23.1047 3.96932 22.5161 3.96932 22.5161L4.3938 20.0146L7.15591 19.8144L7.37753 17.1138L10.2874 17.059L10.3161 14.1686L13.4054 14.2898L13.9331 13.2027C14.8418 13.5893 15.6685 13.7451 16.7298 13.7451C20.746 13.7451 24 10.6637 24 6.86678C24 3.06985 20.7436 0 16.7274 0C12.7112 0 9.5803 3.08139 9.5803 6.87832ZM20.6469 5.53958C20.6469 5.98297 20.5133 6.4164 20.263 6.78506C20.0127 7.15372 19.657 7.44106 19.2408 7.61074C18.8245 7.78041 18.3666 7.82481 17.9247 7.73831C17.4828 7.65181 17.077 7.4383 16.7584 7.12478C16.4399 6.81125 16.2229 6.4118 16.135 5.97694C16.0471 5.54207 16.0923 5.09132 16.2647 4.68168C16.4371 4.27205 16.729 3.92193 17.1036 3.67559C17.4782 3.42926 17.9186 3.29778 18.3691 3.29778C18.6683 3.29748 18.9646 3.35526 19.2411 3.46781C19.5176 3.58036 19.7689 3.74548 19.9804 3.95371C20.192 4.16194 20.3598 4.4092 20.4741 4.68132C20.5885 4.95345 20.6472 5.2451 20.6469 5.53958Z" fill="#D8FB50"/>
</svg>

   
);